var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8.30078,
    cy: 8,
    r: 8,
    fill: "#033DD2"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.90377 13.7467C8.66911 13.7467 8.47177 13.6827 8.31177 13.5547C8.16244 13.4267 8.08777 13.2347 8.08777 12.9787V6.48275C8.08777 6.22675 8.16244 6.03475 8.31177 5.90675C8.47177 5.76808 8.66911 5.69875 8.90377 5.69875C9.13844 5.69875 9.33044 5.76808 9.47977 5.90675C9.62911 6.03475 9.70377 6.22675 9.70377 6.48275V12.9787C9.70377 13.2347 9.62911 13.4267 9.47977 13.5547C9.33044 13.6827 9.13844 13.7467 8.90377 13.7467ZM8.90377 4.13075C8.59444 4.13075 8.34911 4.04541 8.16777 3.87475C7.98644 3.70408 7.89577 3.48008 7.89577 3.20275C7.89577 2.92541 7.98644 2.70675 8.16777 2.54675C8.34911 2.37608 8.59444 2.29075 8.90377 2.29075C9.20244 2.29075 9.44244 2.37608 9.62377 2.54675C9.81577 2.70675 9.91177 2.92541 9.91177 3.20275C9.91177 3.48008 9.82111 3.70408 9.63977 3.87475C9.45844 4.04541 9.21311 4.13075 8.90377 4.13075Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static-sp/media/info.3e83ae371ce4a420621809a35669d05a.svg";
export { ForwardRef as ReactComponent };